var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFastForward = function SvgFastForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.488 4.269A1.6 1.6 0 0 0 0 5.6v12.8a1.6 1.6 0 0 0 2.488 1.331l8.712-5.808V18.4a1.6 1.6 0 0 0 2.488 1.331l9.6-6.4a1.6 1.6 0 0 0 0-2.662l-9.6-6.4A1.6 1.6 0 0 0 11.2 5.6v4.477z"
  })));
};
export default SvgFastForward;